import { StreamChat } from "stream-chat";
export class StreamChatAdapter {
  client;
  channel;
  user;
  constructor(apiKey) {
    this.client = StreamChat.getInstance(apiKey);
    this.channel = null;
    this.user = null;
  }
  async connect(id, token, name = "Anonymous User") {
    const user = await this.client.connectUser({ id, name }, token);
    if (!user || !user.me) throw new Error("Failed to connect user");
    this.user = user.me;
  }
  async setConversation(channelType, conversationId) {
    const channel = this.client.channel(channelType, conversationId);
    await channel.watch();
    this.channel = channel;
  }
  async sendMessage(text, customData = {}) {
    if (!this.channel) throw new Error("No active channel.");
    try {
      await this.channel.sendMessage({ text, customData });
    } catch (error) {
      console.error("Failed to send message:", error);
      throw error;
    }
  }
  onMessageReceived(callback) {
    if (!this.channel) return;
    this.channel.on("message.new", (event) => {
      callback(event.message);
    });
  }
  getMessages() {
    if (!this.channel) return [];
    return this.channel.state.messages;
  }
  async disconnect() {
    try {
      if (this.channel) {
        await this.channel.stopWatching();
        this.channel = null;
      }
      if (this.user) {
        await this.client.disconnectUser();
        this.user = null;
      }
      console.log("Disconnected from Stream Chat");
    } catch (error) {
      console.error("Error during disconnect:", error);
    }
  }
}
